












































import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import LinePreload from "@/components/common/preloaders/LinePreload.vue";

@Component({
  components: {
    LinePreload
  },
  computed: mapGetters("products", [
    "getCategory",
    "getCategories",
    "getProducts",
    "isLangChanging"
  ])
})
export default class Title extends Vue {
  getCategory: any;
  getCategories: any[];
  isLangChanging: boolean;

  getCurrentCategoryName() {
    const currentCat = this.getCategories.filter(cat => {
      return this.getCategory === cat["category_id"];
    })[0];

    return currentCat ? currentCat.name : "";
  }

  destroyed() {
    this.$store.dispatch("products/removeProducts");
  }
}
